import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { Link } from '@ardoq/link';
import { currentDate, parseDate } from '@ardoq/date-time';

export const AutolinkAndDateDashboardFilterNotification = () => {
  return (
    <FlexBox flexDirection="column">
      <Text variant="text2Bold">
        Introducing dashboard filters with smart suggestions
      </Text>
      <Text variant="text2">
        Link multiple charts to a{' '}
        <Link
          href={KnowledgeBaseLink.DASHBOARD_FILTERS}
          hideIcon
          target="_blank"
          typography="text2"
        >
          single filter for date, number, reference, text, or list columns
        </Link>
        . Ardoq even identifies compatible charts as you work and offers to link
        them automatically.
      </Text>
    </FlexBox>
  );
};

const FEATURE_RELEASE_DATE = '2026-02-24';

export const isAutolinkAndDateDashboardFilterNotificationExpired =
  (): boolean => {
    const twoWeeksAfterRelease = parseDate(FEATURE_RELEASE_DATE);
    twoWeeksAfterRelease.setDate(twoWeeksAfterRelease.getDate() + 14);

    return currentDate().getTime() > twoWeeksAfterRelease.getTime();
  };
